import React from 'react'
import { Table, LoaderWrapper } from './Grid.styles'

import TableHeadRowContainer from './tableheadrow/TableHeadRow.container'
import TableRowContainer from './tablerow/TableRow.container'
import NoResultRow from './noresults/NoResultRow.container'

import Loader from "@emcm-ui/component-loader";

const GridComponent = ({
  serverRequestInFlight,
  env,
  i18n,
  api,
  analytics,
  style,
  events,
  data,
  rowFlag,
  selectiveMultiSelectRows,
  multiselect,
  openParentRows,
  rowActions,
  subRows,
  freezeCol,
  headers,
  multiLineRow,
  scrollOffset,
  selectedRows,
  handleSort,
  handleFilter,
  datasetWidth,
  headerChecked
}) => {
  return (
    <Table style={style}>
      <thead>
        <TableHeadRowContainer
          env={env}
          analytics={analytics}
          api={api}
          handleSort={handleSort}
          handleFilter={handleFilter}
          handleSelectAll={events.handleSelectAll}
          style={style}
          data={data}
          rowFlag={rowFlag}
          selectiveMultiSelectRows={selectiveMultiSelectRows}
          openParentRows={openParentRows}
          multiselect={multiselect}
          rowActions={rowActions}
          subRows={subRows}
          freezeCol={freezeCol}
          headers={headers}
          multiLineRow={multiLineRow}
          scrollOffset={scrollOffset}
          selectedRows={selectedRows}
          headerChecked={headerChecked}
        />
      </thead>
      <tbody>
        {serverRequestInFlight &&
          <tr>
            <td colSpan={headers.length}>
              <div style={{width: datasetWidth + 'px', textAlign: 'center'}}>
                <LoaderWrapper>
                  <Loader />
                </LoaderWrapper>
              </div>

            </td>
          </tr>
        }

        {!serverRequestInFlight && data && data.length < 1 &&
          <tr><NoResultRow headers={headers} api={api} i18n={i18n} datasetWidth={datasetWidth} handleFilter={handleFilter} handleSort={handleSort} env={env} /></tr>
        }
        {!serverRequestInFlight && data && data.length > 0 &&
          data.map((dataRow, i) => {
            const multiSelectState = selectiveMultiSelectRows.filter((row) => {
              return (row.uuid === dataRow.uuid)
            })

            const subRowArr = []

            if (openParentRows.indexOf(dataRow.uuid) > -1) {
              const subs = dataRow[subRows.datafield]

              subs.forEach((sub, ii) => {
                const subData = sub

                subData.uuid = dataRow.uuid + '_sub_' + ii

                subRowArr.push(
                  <TableRowContainer
                    selectedRows={selectedRows}
                    env={env}
                    analytics={analytics}
                    multiselected={selectedRows.indexOf(subData.uuid) > -1}
                    multiselect={multiselect}
                    multiselectenabled={multiSelectState.length > 0}
                    handleMultiSelectChanged={events.handleMultiSelectChanged}
                    rowActions={rowActions}
                    subRows={false}
                    isSubRow={true}
                    freezeCol={freezeCol}
                    keyValue={'table_' + subData.uuid + '_subrow_' + ii}
                    key={'table_' + subData.uuid + '_subrow_' + ii}
                    dataRow={subData}
                    headers={headers}
                    multiLineRow={multiLineRow}
                    scrollOffset={scrollOffset}
                    headerChecked={headerChecked}
                  />
                )
              })
            }

            let output = [
              <TableRowContainer
                selectedRows={selectedRows}
                env={env}
                analytics={analytics}
                rowFlag={rowFlag}
                multiselected={selectedRows.indexOf(dataRow.uuid) > -1}
                multiselect={multiselect}
                multiselectenabled={multiSelectState.length > 0}
                handleMultiSelectChanged={events.handleMultiSelectChanged}
                rowActions={rowActions}
                handleSubRowChanged={events.handleSubRowChanged}
                subRows={subRows}
                freezeCol={freezeCol}
                keyValue={'tablerow_' + dataRow.uuid}
                key={'tablerow_' + dataRow.uuid}
                dataRow={dataRow}
                headers={headers}
                multiLineRow={multiLineRow}
                scrollOffset={scrollOffset}
                headerChecked={headerChecked}
              />
            ]

            output = output.concat(subRowArr)

            return output
          })
        }
      </tbody>
    </Table>
  )
}

export default GridComponent
